module.exports = __webpack_public_path__ + "static/job-asking-33038b152b322cafaf2e50a8552b3f22.png";